import { IconButton } from "@rmwc/icon-button";
import "@rmwc/icon-button/styles";
import { RCTooltip } from "@rmwc/rc-tooltip";
import "@rmwc/rc-tooltip/styles";
import PropTypes from "prop-types";
import moment from "moment";
import { useState } from "react";
import Countdown, { zeroPad } from "react-countdown";
import { useTranslation } from "react-i18next";
import "./DistributionCountDown.css";

// #region FONCTION COMPOSANT
/**
 * Composant permettant d'afficher un timer
 * @category Distribution
 * @param {DistributionCountDown.propTypes} props Les propriétés du composant
 */
function DistributionCountDown(props) {
  //#region INITIALISATION
  const { detailAchat } = props;
  const { t } = useTranslation();
  const isParking = detailAchat?.idServiceType === 4;
  const initialDepassement = detailAchat && moment(detailAchat.dateLimiteValidite).isBefore(moment());
  const [isDepassement, setIsDepassement] = useState(initialDepassement);
  // #endregion

  //#region INTERFACE
  const dayAbbr = t("distribution.timeDayAbbr");

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    const inDepassement = completed || (detailAchat && moment(detailAchat.dateLimiteValidite).isBefore(moment()));

    if (inDepassement && isParking) {
      const diff = moment().diff(moment(detailAchat.dateLimiteValidite));
      const d = moment.duration(diff);
      const j = Math.floor(d.asDays());
      const h = d.hours();
      const m = d.minutes();
      const negStr = `-${j ? j + dayAbbr + " " : ""}${zeroPad(h, 2)}h ${zeroPad(m, 2)}m`.trim();
      return <span className="DistributionCountDown-Depassement">{negStr}</span>;
    }

    if (days + hours + minutes === 0 && seconds !== 0) {
      return <span>{(`${days ? days + dayAbbr : ""} ${zeroPad(hours, 2)}h ${zeroPad(minutes, 2)}m${zeroPad(seconds, 2)}`).trim()}</span>;
    }

    return <span>{(`${days ? days + dayAbbr : ""} ${zeroPad(hours, 2)}h ${zeroPad(minutes, 2)}m`).trim()}</span>;
  };

  if (!detailAchat) {
    return null;
  }

  if (detailAchat.idServiceType === 10) {
    return (
      <div className="DistributionCountDown-Container">
        {detailAchat.quantite + " " + t("distribution.unite")}
      </div>
    );
  }

  const tooltipContent = isDepassement ? t("distribution.enDepassement") : t("distribution.remainingTime");

  return (
    <div className="DistributionCountDown-Container">
      <RCTooltip content={tooltipContent}>
        <span style={{ display: "flex", alignItems: "center" }}>
          <IconButton icon="alarm" />
          <Countdown
            date={detailAchat.dateLimiteValidite}
            precision={3}
            renderer={renderer}
            onComplete={() => setIsDepassement(true)}
          />
        </span>
      </RCTooltip>
    </div>
  );
  // #endregion
};
// #endregion

// #region PROPRIETES
/**
 * Type des propriétés de {@link DistributionCountDown}
 * @typedef {Object} DistributionCountDown.propTypes
 * @property {object} detailAchat Le détail de l'achat
 */
DistributionCountDown.propTypes = {
  detailAchat: PropTypes.object.isRequired
};
// #endregion

export { DistributionCountDown };

